import dynamic from "next/dynamic";

export const BlogPostsCarousel = dynamic(() => import("./component"));
